export const ACCOUNT_MENU_TEXT = {
  label: '계정 메뉴',
  info: '정보 수정',
  config: '환율 수정',
  'access-log': '접속 로그',
  logout: '로그아웃',
  /** 로그아웃 확인 창(기존 Header.menu.form 의 window.confirm) */
  logoutConfirm: '로그아웃 하시겠습니까?',
} as const;
